import { Grid, Paper, Typography } from '@mui/material'
import { memo } from 'react'
import { formatOiQuantity } from '../../util/screener'
import { participantBarDefaultColor } from './OIChart'
import { BarLabelView } from '../../components/participantOpenInterest/BarLabel'
import { oiMetricLabelSx } from './OiAnalysisFooter'

type TooltipProps = {
    colors: Map<string, string>,
    data: { data: { date: string } & any, leftScaleData?: { date: string } & any },
    keys: string[],
    leftScaleKeys: string[],
    specificColors?: { [key: string]: (value: string) => string }
}

export const ToolTipView = memo(({ colors, data, keys, leftScaleKeys, specificColors }: TooltipProps) => {
    const date = data.data.date

    return (<Paper
        sx={{ padding: 1, margin: 0, backgroundColor: (theme) => theme.palette.background.default }}>
        <Grid item gap={2} sx={{ textAlign: 'left' }}>
            <Typography variant="body2" fontWeight={500} sx={{ textAlign: 'left' }}>
                {date}
            </Typography>
            {
                keys.map((key) => {
                    const value = data.data[key]
                    const color = specificColors && specificColors[key] ? specificColors[key](value) : colors.get(key) ?? participantBarDefaultColor
                    return (
                        <Grid key={key} container gap={2} width={'100%'} justifyContent="space-between" alignItems="center">
                            <BarLabelView label={key} color={color} labelSx={oiMetricLabelSx} />
                            <Typography variant={'body2'}>{formatOiQuantity(value)}</Typography>
                        </Grid>)
                })
            }
            {
                data.leftScaleData && leftScaleKeys.map((key) => {
                    return (
                        <Grid key={`left-${key}`} width={'100%'} container gap={2} justifyContent="space-between" alignItems="center">
                            <BarLabelView label={key} color={colors.get(key) ?? participantBarDefaultColor} labelSx={oiMetricLabelSx} />
                            <Typography variant={'body2'}>{data.leftScaleData[key].toFixed(2)}</Typography>
                        </Grid>)
                })
            }
        </Grid>
    </Paper>)
})